/**
 * The current AECOM estate is served from `*.aecom.team` (non-production and
 * per-developer PDEs) and `*.aecom.services` (production).
 *
 * Behaviour that only applies to the rebuilt estate — e.g. the private,
 * SAS-gated report-templates blob storage — keys off this check.
 */
export const isRebuildHost = (hostname) => hostname.endsWith('.aecom.team') || hostname.endsWith('.aecom.services');
/**
 * Whether the current browser deployment is part of the current AECOM estate.
 * Falls back to `false` when the hostname is unavailable.
 */
export const isRebuildEnvironment = () => {
    try {
        return isRebuildHost(window.location.hostname);
    }
    catch {
        return false;
    }
};
